// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604291438/js/" + chunkId + "." + {"44":"8e77eddc","225":"602a6801","481":"5e9c3671","486":"bf159c79","770":"655eac92"}[chunkId] + ".0.4087255763279791.chunk.js";
};